/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Trial_Reminder_Title_2Inputs */

const en_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We’ll remind you <span style="color: #2AFD00;">${i?.number} days</span> before your trial ends`)
};

const ar_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`سنذكّرك قبل انتهاء الفترة التجريبية. عدد الأيام المتبقية حينها: <span style="color: #2AFD00;">${i?.number}</span>`)
};

const de_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wir erinnern Sie <span style="color: #2AFD00;">${i?.number} Tage</span> vor Ablauf Ihrer Testphase`)
};

const es_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Te lo recordaremos <span style="color: #2AFD00;">${i?.number} días</span> antes de que termine tu periodo de prueba`)
};

const fr_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nous vous rappellerons <span style="color: #2AFD00;">${i?.number} jours</span> avant la fin de votre essai`)
};

const it_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ti ricorderemo <span style="color: #2AFD00;">${i?.number} giorni</span> prima della fine del periodo di prova`)
};

const ja_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トライアル終了の<span style="color: #2AFD00;">${i?.number}日前</span>にお知らせします`)
};

const ko_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`무료 체험 종료 <span style="color: #2AFD00;">${i?.number}일 전</span>에 알려드릴게요`)
};

const pt_br_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vamos enviar um lembrete <span style="color: #2AFD00;">${i?.number} dias</span> antes do fim do teste grátis`)
};

const ru_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Мы напомним вам за <span style="color: #2AFD00;">${i?.number} дн.</span> до окончания пробного периода`)
};

const th_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เราจะแจ้งเตือนคุณ<span style="color: #2AFD00;">${i?.number} วัน</span>ก่อนช่วงทดลองใช้สิ้นสุด`)
};

const tr_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deneme süren sona ermeden <span style="color: #2AFD00;">${i?.number} gün</span> önce sana hatırlatacağız`)
};

const zh_cn_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我们会在免费体验到期前 <span style="color: #2AFD00;">${i?.number} 天</span>提醒你`)
};

const zh_tw_trial_reminder_title_2 = /** @type {(inputs: Trial_Reminder_Title_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`放心啦～免費體驗到期前 <span style="color: #2AFD00;">${i?.number} 天</span>，我們會提醒你！`)
};

/**
* | output |
* | --- |
* | "We’ll remind you <span style=\"color: #2AFD00;\">{number} days</span> before your trial ends" |
*
* @param {Trial_Reminder_Title_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const trial_reminder_title_2 = /** @type {((inputs: Trial_Reminder_Title_2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trial_Reminder_Title_2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trial_reminder_title_2(inputs)
	if (locale === "ar") return ar_trial_reminder_title_2(inputs)
	if (locale === "de") return de_trial_reminder_title_2(inputs)
	if (locale === "es") return es_trial_reminder_title_2(inputs)
	if (locale === "fr") return fr_trial_reminder_title_2(inputs)
	if (locale === "it") return it_trial_reminder_title_2(inputs)
	if (locale === "ja") return ja_trial_reminder_title_2(inputs)
	if (locale === "ko") return ko_trial_reminder_title_2(inputs)
	if (locale === "pt_br") return pt_br_trial_reminder_title_2(inputs)
	if (locale === "ru") return ru_trial_reminder_title_2(inputs)
	if (locale === "th") return th_trial_reminder_title_2(inputs)
	if (locale === "tr") return tr_trial_reminder_title_2(inputs)
	if (locale === "zh_cn") return zh_cn_trial_reminder_title_2(inputs)
	return zh_tw_trial_reminder_title_2(inputs)
});